webpackJsonp([56433184127772],{

/***/ 458:
/***/ (function(module, exports) {

	module.exports = { prefix: 'fas', iconName: 'microphone', icon: [384, 512, [], "f130", "M96 256V96c0-53.019 42.981-96 96-96s96 42.981 96 96v160c0 53.019-42.981 96-96 96s-96-42.981-96-96zm252-56h-24c-6.627 0-12 5.373-12 12v42.68c0 66.217-53.082 120.938-119.298 121.318C126.213 376.38 72 322.402 72 256v-44c0-6.627-5.373-12-12-12H36c-6.627 0-12 5.373-12 12v44c0 84.488 62.693 154.597 144 166.278V468h-68c-6.627 0-12 5.373-12 12v20c0 6.627 5.373 12 12 12h184c6.627 0 12-5.373 12-12v-20c0-6.627-5.373-12-12-12h-68v-45.722c81.307-11.681 144-81.79 144-166.278v-44c0-6.627-5.373-12-12-12z"] };

/***/ }),

/***/ 459:
/***/ (function(module, exports) {

	module.exports = { prefix: 'fas', iconName: 'music', icon: [512, 512, [], "f001", "M470.4 1.5l-304 96C153.1 101.7 144 114 144 128v264.6c-14.1-5.4-30.5-8.6-48-8.6-53 0-96 28.7-96 64s43 64 96 64 96-28.7 96-64V220.5l272-85.9v194c-14.1-5.4-30.5-8.6-48-8.6-53 0-96 28.7-96 64s43 64 96 64 96-28.7 96-64V32c0-21.7-21.1-37-41.6-30.5z"] };

/***/ }),

/***/ 462:
/***/ (function(module, exports) {

	module.exports = { prefix: 'fas', iconName: 'star', icon: [576, 512, [], "f005", "M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"] };

/***/ }),

/***/ 463:
/***/ (function(module, exports) {

	module.exports = { prefix: 'fas', iconName: 'trophy', icon: [576, 512, [], "f091", "M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"] };

/***/ }),

/***/ 464:
/***/ (function(module, exports) {

	module.exports = { prefix: 'fas', iconName: 'user-circle', icon: [512, 512, [], "f2bd", "M8 256C8 119.033 119.033 8 256 8s248 111.033 248 248-111.033 248-248 248S8 392.967 8 256zm72.455 125.868C119.657 436.446 183.673 472 256 472s136.343-35.554 175.545-90.132c-3.141-26.99-22.667-49.648-49.538-56.366l-32.374-8.093C323.565 339.79 290.722 352 256 352s-67.565-12.21-93.634-34.591l-32.374 8.093c-26.87 6.718-46.396 29.376-49.537 56.366zM144 208c0 61.856 50.144 112 112 112s112-50.144 112-112S317.856 96 256 96s-112 50.144-112 112z"] };

/***/ }),

/***/ 465:
/***/ (function(module, exports) {

	module.exports = { prefix: 'fas', iconName: 'video', icon: [576, 512, [], "f03d", "M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"] };

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _kebabCase = __webpack_require__(186);
	
	var _kebabCase2 = _interopRequireDefault(_kebabCase);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactFontawesome = __webpack_require__(78);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _faMicrophone = __webpack_require__(458);
	
	var _faMicrophone2 = _interopRequireDefault(_faMicrophone);
	
	var _faTrophy = __webpack_require__(463);
	
	var _faTrophy2 = _interopRequireDefault(_faTrophy);
	
	var _faUserCircle = __webpack_require__(464);
	
	var _faUserCircle2 = _interopRequireDefault(_faUserCircle);
	
	var _faMusic = __webpack_require__(459);
	
	var _faMusic2 = _interopRequireDefault(_faMusic);
	
	var _faVideo = __webpack_require__(465);
	
	var _faVideo2 = _interopRequireDefault(_faVideo);
	
	var _faStar = __webpack_require__(462);
	
	var _faStar2 = _interopRequireDefault(_faStar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TAGS = {
	  "award show": _faTrophy2.default,
	  "radio": _faMicrophone2.default,
	  "interview": _faUserCircle2.default,
	  "music show": _faMusic2.default,
	  "cf": _faVideo2.default,
	  "variety": _faStar2.default
	};
	
	function getIcon(tag) {
	  console.log(tag);
	
	  if (!(tag.toLowerCase() in TAGS)) {
	    return null;
	  }
	
	  return TAGS[tag.toLowerCase()];
	}
	
	var _class = function (_React$Component) {
	  _inherits(_class, _React$Component);
	
	  function _class() {
	    _classCallCheck(this, _class);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  _class.prototype.render = function render() {
	    var tags = this.props.tags;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "columns is-centered" },
	      _react2.default.createElement(
	        "div",
	        { className: "column is-two-thirds" },
	        _react2.default.createElement(
	          "div",
	          { className: "columns is-multiline is-mobile" },
	          tags.map(function (tag) {
	            return _react2.default.createElement(
	              "div",
	              { key: tag.fieldValue, className: "column is-one-third has-text-centered" },
	              _react2.default.createElement(
	                "div",
	                { className: "box" },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: "/tags/" + (0, _kebabCase2.default)(tag.fieldValue) + "/" },
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    _react2.default.createElement(
	                      "span",
	                      { className: "icon icon is-large" },
	                      _react2.default.createElement(_reactFontawesome2.default, { icon: getIcon(tag.fieldValue), size: "3x" })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    tag.fieldValue + " (" + tag.totalCount + ")"
	                  )
	                )
	              )
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return _class;
	}(_react2.default.Component);
	
	exports.default = _class;
	module.exports = exports["default"];

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _HeaderImage = __webpack_require__(58);
	
	var _HeaderImage2 = _interopRequireDefault(_HeaderImage);
	
	var _VideoTypes = __webpack_require__(507);
	
	var _VideoTypes2 = _interopRequireDefault(_VideoTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VideosByTypePage = function VideosByTypePage(_ref) {
	  var _ref$data = _ref.data,
	      group = _ref$data.allMarkdownRemark.group,
	      videosHeaderImage = _ref$data.videosHeaderImage;
	
	
	  // filter by era client side since apparently you can't filter
	  // graphql queries with substrings in arrays?
	  var TypeTags = group.filter(function (x) {
	    return !x.fieldValue.toLowerCase().includes("era");
	  });
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: "Videos By Type" }),
	    _react2.default.createElement(_HeaderImage2.default, { headerImage: videosHeaderImage }),
	    _react2.default.createElement(
	      "div",
	      { className: "section" },
	      _react2.default.createElement(
	        "div",
	        { className: "container", style: { paddingTop: "100px" } },
	        _react2.default.createElement(
	          "h1",
	          { className: "title is-1" },
	          "Videos By Type"
	        ),
	        _react2.default.createElement(_VideoTypes2.default, { tags: TypeTags })
	      )
	    )
	  );
	};
	
	exports.default = VideosByTypePage;
	
	/* eslint no-undef: "off" */
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-videos-by-type-jsx-6647059279d731a54950.js